import { clamp } from '#shared'
import styles from './progress-bar.module.css'

interface ProgressBarProps {
  /** From 0 to 1, or `null` when the progress isn't known yet (indeterminate). */
  readonly value: number | null
  /** Accessible name, e.g. "Loading". */
  readonly label: string
}

export function ProgressBar({ value, label }: ProgressBarProps) {
  if (value === null) {
    return (
      <div role="progressbar" aria-label={label} class={styles.track}>
        <div class={styles.indeterminate} />
      </div>
    )
  }

  const percent = Math.round(clamp(value, 0, 1) * 100)
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
      class={styles.track}
    >
      <div class={styles.fill} style={{ transform: `scaleX(${String(percent / 100)})` }} />
    </div>
  )
}
